import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  Replay as IconReload,
  AddBox as IconAdd,
  Edit as IconEdit,
  Check as IconCheck,
  Close as IconClose,
  PictureAsPdf as IconPdf,
  Article as IconFile,
} from "@mui/icons-material";

import TxtBox from "components/Custom/TxtBox";
import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import SwitchBtn from "components/Custom/SwitchBtn";
import AutoComplete from "components/Custom/AutoComplete";
import ConfirmDialog from "components/Custom/ConfirmDialog";
import Loader from "components/Custom/Loader";
import UsersSkeleton from "./UsersSkeleton";
import { ApiMasters } from "apihandlers//masters/masters";
import { ApiIndents } from "apihandlers//indent";
import { NOTIFY, DEFAULTS } from "common/config";
import { COLORS } from "common/colors";
import { LABELS, ERRORS, WARNINGS, SUCCESS, CONFIRMS } from "common/labels";

import { COMMON_JS } from "common/scripts";

const ApiMastersHandler = new ApiMasters();
const ApiIndentHandler = new ApiIndents();
let _timer = null;

const Odometer = (props: any) => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [indentGroup, setIndentGroup] = useState<any>(null);

  const [filteredRows, setFilteredRows] = useState([]);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getTripsList();
    }
  }, [loading]);

  const getTripsList = () => {
    const args = {
      minResponse: true,
    };
    ApiIndentHandler.getTripsList(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.indentId,
            label: r.indentNo,
          };
        });
        console.log("gettrip", list);
        setIndentGroup(list);
        getRows();
      }
    });
  };

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      // fromDate: fdt,
      // toDate: tdt,
    };
    ApiIndentHandler.getOdometerInfo(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setFilteredRows([]);
        setLoading(false);
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const columns: GridColDef[] = [
    {
      field: "slNo",
      headerName: "Sl No.",
      width: 100,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    { field: "indentNumber", headerName: "Indent", width: 150 },
    { field: "vehicleNo", headerName: "Vehicle No", width: 150 },
    { field: "openingOdometer", headerName: "Opening KM", width: 150 },
    { field: "enteredOn", headerName: "Opening Date", width: 150 },
    { field: "closingOdometer", headerName: "Closing KM", width: 150 },
    { field: "reportedOn", headerName: "Closing Date", width: 150 },
    // { field: "activeStatusText", headerName: "Active", width: 100 },
    {
      field: "options",
      headerName: "Options",
      width: 150,
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRecord = () => {
    const openingKm = (
      document.getElementById("openingKm") as HTMLInputElement
    ).value.trim();
    const closingKm = (
      document.getElementById("closingKm") as HTMLInputElement
    ).value.trim();
    const indentId = indentIdRef.current.selectedValue.id;
    const activeStatus = (
      document.getElementById("isActive") as HTMLInputElement
    ).checked;
    const enteredDate = (
      document.getElementById("enteredDate") as HTMLInputElement
    ).value.trim();
    const reachedDate = (
      document.getElementById("reachedDate") as HTMLInputElement
    ).value.trim();

    // Validations
    // if (!name) {
    //   COMMON_JS.showNotify(
    //     props,
    //     NOTIFY.WARNING,
    //     WARNINGS.MANDATORY
    //   );
    //   return;
    // }

    const args = {
      id: selectedRow.id || -1,
      indentId: indentId,
      enteredDate: enteredDate,
      reachedDate: reachedDate,
      lat: 0,
      lng: 0,
      openingKm: Number(openingKm),
      closingKm: Number(closingKm),
      status: activeStatus.toString(),
    };

    console.log("manage", args);

    ApiIndentHandler.manageTripStatus(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const deleteUser = ({ id }) => {
    // console.log("deleteUser: ", id);
    setRows(null);
    // getUsers();
  };

  const reloadGrid = () => {
    setRows(null);
    setTimeout(() => {
      getRows();
    }, 2000);
  };

  const onSearch = (e: any) => {
    const qry = e.target.value.trim().toUpperCase();
    clearTimeout(_timer);
    _timer = setTimeout(() => {
      let flist = rows.filter((r: any) => {
        let group = r.indentNo || "";
        let driver = r.driverName || "";
        return (
          group.toUpperCase().indexOf(qry) > -1 ||
          driver.toUpperCase().indexOf(qry) > -1
        );
      });
      // console.log("flist: ", rows, flist, qry);
      if (flist.length === 0) {
        flist = null;
      } else {
        flist = flist.map((f, i) => {
          f.slNo = i + 1;
          return f;
        });
      }
      setFilteredRows(flist);
    }, 150);
  };

  const vehicleRef: any = useRef(null);
  const indentIdRef: any = useRef();
  const vehicleIdRef: any = useRef();
  const chargedIdRef: any = useRef();
  const driverIdRef: any = useRef();

  // console.log("Users: ", loading, selectedRow.active);
  // console.log("selectedRow",selectedRow)
  // console.log("vehicleTypes",vehicleTypes)

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{LABELS.TRANSACTION_BUTTON_ODO}</li>
        </ul>
        <h4>{LABELS.TRANSACTION_BUTTON_ODO}</h4>
        {/* <p>{SUB_TITLES.USERS}</p> */}
      </div>

      {rows && (
        <div className="gridOption">
          <TxtBox placeholder={LABELS.SEARCH} onKeyPress={onSearch} />
          <IconButton className="iconBtn" onClick={reloadGrid}>
            <IconReload />
          </IconButton>
          <IconButton
            className="iconBtn"
            onClick={() => {
              setManageDialog(!manageDialog);
              setSelectedRow({});
            }}
          >
            <IconAdd />
          </IconButton>
        </div>
      )}

      <div
        className="grid"
        style={{
          width: "98%",
          height: "80%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {rows ? (
          <DataGrid
            rows={
              !filteredRows ? [] : filteredRows.length > 0 ? filteredRows : rows
            }
            columns={columns}
            rowHeight={50}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            disableColumnMenu={true}
            disableSelectionOnClick={true}
          />
        ) : (
          <Loader />
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit Trip Expense: " + selectedRow.indentNo
              : "Add Trip Expense"
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
          }}
        >
          <div className="formGroup">
            <label>{"Indent Number"}</label>
            <AutoComplete
              id={"indentNo"}
              list={indentGroup}
              childRef={indentIdRef}
              defaultValue={
                selectedRow.indentId
                  ? {
                      id: selectedRow.indentId,
                      label: selectedRow.indentNumber,
                    }
                  : null
              }
            />
          </div>
          <div className="formGroup">
            <label>{"Trip Start"}</label>
            <TxtBox
              id={"enteredDate"}
              placeholder={"Trip Start"}
              defaultValue={selectedRow.enteredOn}
              type={"datetime-local"}
            />
          </div>
          <div className="formGroup">
            <label>{"Trip Opening"}</label>
            <TxtBox
              id={"openingKm"}
              placeholder={"Opening Odometer reading before Trip"}
              defaultValue={selectedRow.openingOdometer}
            />
          </div>
          <div className="formGroup">
            <label>{"Trip End"}</label>
            <TxtBox
              id={"reachedDate"}
              placeholder={"Trip End"}
              defaultValue={selectedRow.reportedOn}
              type={"datetime-local"}
            />
          </div>
          <div className="formGroup">
            <label>{"Trip Closing"}</label>
            <TxtBox
              id={"closingKm"}
              placeholder={"Closing Odometer reading after Trip"}
              defaultValue={selectedRow.closingOdometer}
            />
          </div>
          <div className="formGroup">
            <SwitchBtn
              text={LABELS.ACTIVE}
              id={"isActive"}
              checked={selectedRow.id ? selectedRow.activeStatus : true}
            />
          </div>
          <div
            className="formGroup"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 25,
            }}
          >
            <div
              style={{
                width: "45%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Btn text={LABELS.SAVE} onClick={manageRecord} />
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.DIM_DARK_GRAY}
                onClick={() => setManageDialog(false)}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Odometer);
